/* assets/cart-gbg-preview.js — v3.1 (Cart GBG renderer, JPG/PNG, robust normalize) */
(function () {
  if (window.__CART_GBG_PREVIEW_V31__) return;
  window.__CART_GBG_PREVIEW_V31__ = true;

  const DBG = false;
  const log = (...a) => { if (DBG) console.log('[cart-gbg]', ...a); };

  function styleVariants(raw){
    const base = String(raw||"").toLowerCase()
      .replace(/&/g,"and")
      .replace(/[^a-z0-9\s-]/g," ")
      .replace(/\s+/g," ")
      .trim();
    const under = base.replace(/\s+/g,"_");
    const dash  = base.replace(/\s+/g,"-");
    return Array.from(new Set([under, dash, base].filter(Boolean)));
  }

  function normalizeStyleForFilename(raw){
    const t = String(raw||"").toLowerCase();
    const has = s => t.indexOf(s) >= 0;

    // old-site canonical names
    if (has("equal") && has("lite")) return "equal_lite";
    if ((has("4")||has("four")) && has("lite") && has("tall")) return "4_lite_tall";
    if ((has("9")||has("nine")) && has("lite") && (has("prairie")||has("prarie"))) return "9_lite_prairie";
    if (has("prarie")) return "9_lite_prairie";

    // fallback to normalized variants
    return styleVariants(raw)[0] || "equal_lite";
  }

  function normalizeGridPattern(s){
    if(!s) return null;
    let t = String(s).toLowerCase();

    // accept: "2 W x 2 H", "2W x 2H", "2w x2h", "2W X 2H"
    t = t.replace(/\s+/g,"");
    t = t.replace(/[×]/g,"x");
    t = t.replace(/(\d+)w?x(\d+)h?/,"$1w$2h");
    t = t.replace(/[^0-9whx]/g,"");

    // final enforce: 2w2h
    const m = t.match(/(\d+)w(\d+)h/);
    return m ? `${m[1]}w${m[2]}h` : null;
  }

  function gridTo2x2(slug){
    const m = (slug||"").match(/(\d+)w(\d+)h/);
    return m ? `${m[1]}x${m[2]}` : null;
  }

  function primaryBase(gridSlug, styleRaw){
    const g2x2 = gridTo2x2(gridSlug) || gridSlug;
    const st   = normalizeStyleForFilename(styleRaw);
    return `${g2x2}_${st}`;
  }

  function buildCandidateFilenames(gridSlug, styleRaw){
    const g2x2 = gridTo2x2(gridSlug);
    const grids = [g2x2, gridSlug].filter(Boolean);

    const st0 = normalizeStyleForFilename(styleRaw);
    const styles = Array.from(new Set([st0, ...styleVariants(styleRaw)]));

    const bases = [];
    for(const g of grids){
      for(const st of styles){
        bases.push(`${g}_${st}`, `${g}-${st}`, `${g} ${st}`);
      }
    }

    // also try title-case underscore style (old random uploads)
    const outBases = Array.from(new Set(bases)).flatMap(b=>{
      const title = b.split(/[\s-_]/).map(s=> s ? (s[0].toUpperCase()+s.slice(1)) : s).join("_");
      return [b, b.toLowerCase(), title];
    });

    const exts = ["jpg","png","jpeg","webp","JPG","PNG","JPEG","WEBP"];
    const names = [];
    for (const b of outBases){
      for (const e of exts){
        names.push(`${b}.${e}`);
      }
    }
    return Array.from(new Set(names));
  }

  function withWidth(url, box){
    const w = Math.max(80, Math.min(800, Math.round((box.clientWidth||220)*2)));
    return url + (url.includes("?") ? `&width=${w}` : `?width=${w}`);
  }

  function raceLoad(box, filename){
    // Shopify Files URL patterns (support both)
    const bases = ["/files/", "/cdn/shop/files/"];
    const urls  = bases.map(b => withWidth(b + encodeURIComponent(filename), box));
    return new Promise((resolve, reject)=>{
      let done=false, left=urls.length;
      const tried=[];
      urls.forEach(u=>{
        tried.push(u);
        const img = new Image();
        try{ img.decoding="async"; }catch{}
        img.onload = ()=>{ if(!done){ done=true; resolve({img,url:u}); } };
        img.onerror = ()=>{ if(--left===0 && !done) reject(new Error("all failed")); };
        img.src = u;
      });
    });
  }

  async function resolveFast(box, gridSlug, styleRaw){
    // no localStorage cache for cart to keep it simple/stable
    const primary = primaryBase(gridSlug, styleRaw);

    // try primary first, then candidates
    const primaryNames = [
      `${primary}.jpg`, `${primary}.png`, `${primary}.JPG`, `${primary}.PNG`
    ];

    for(const name of primaryNames){
      try { return await raceLoad(box, name); } catch(e) {}
    }

    const names = buildCandidateFilenames(gridSlug, styleRaw);
    for(const name of names){
      try { return await raceLoad(box, name); } catch(e) {}
    }
    throw new Error("no match");
  }

  function mountOne(box){
    const gridRaw  = box.getAttribute("data-grid")  || "";
    const styleRaw = box.getAttribute("data-style") || "";
    const gridSlug = normalizeGridPattern(gridRaw);

    if(!gridSlug || !styleRaw){
      box.style.display = "none";
      box.innerHTML = "";
      return;
    }

    // skeleton placeholder
    if(!box.__sk){
      box.__sk=true;
      box.innerHTML = '<div style="width:60%;height:8px;background:#eee;border-radius:4px;animation:pulse 1s infinite"></div>';
      if(!document.getElementById("gbg-pulse-style")){
        const st=document.createElement("style");
        st.id="gbg-pulse-style";
        st.textContent="@keyframes pulse{0%{opacity:.35}50%{opacity:1}100%{opacity:.35}}";
        document.head.appendChild(st);
      }
    }

    resolveFast(box, gridSlug, styleRaw).then(({img, url})=>{
      box.innerHTML = "";

      // optional sizing from data attrs
      const w = box.getAttribute("data-gbg-w");
      const h = box.getAttribute("data-gbg-h");
      if (w) box.style.width = w;
      if (h) box.style.maxHeight = h;

      img.style.width = "80%";
      img.style.height = "auto";
      img.style.objectFit = "contain";
      img.style.maxHeight = (h || "220px");
      img.loading = "lazy";
      box.appendChild(img);

      // store for bridge/export if needed
      box.setAttribute("data-img", url);
      log("GBG OK", gridRaw, styleRaw, url);
    }).catch((e)=>{
      log("GBG miss", gridRaw, styleRaw, e);
      box.style.display = "none";
      box.innerHTML = "";
    });
  }

  function mount(){
    document.querySelectorAll(".cart-gbg-box").forEach(mountOne);
  }

  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded", mount);
  } else {
    mount();
  }

  // cart can rerender via ajax
  try{
    const mo = new MutationObserver(()=> setTimeout(mount, 60));
    mo.observe(document.querySelector("#main-cart-items") || document.body, {childList:true, subtree:true});
  }catch(e){}
})();
